export const SIZES = [
  { v: "small", l: "Small car", hint: "Hatch, Yaris, Mazda2" },
  { v: "sedan", l: "Sedan", hint: "Camry, Commodore, coupe" },
  { v: "suv", l: "SUV", hint: "RAV4, CX-5, Tucson" },
  { v: "large", l: "7-seater / 4x4", hint: "Prado, Kluger, Ranger" },
];

export const sizeLabel = (v) => SIZES.find((s) => s.v === v)?.l || v;

export function priceFor(item, size) {
  if (!item) return 0;
  const p = item.prices || {};
  const vals = Object.values(p);
  if (vals.length) return p[size] ?? Math.min(...vals);
  return item.price || 0;
}

export const hasSizePricing = (item) => {
  const vals = Object.values(item?.prices || {});
  return vals.length > 0 && new Set(vals).size > 1;
};
